/* eslint-disable no-console */
import type { AnyFn } from '@vueuse/core'

// export function useFullscreenAds(gameId: MaybeRef<number>) {
//   /** 全屏广告 key:游戏ID value:下次观看时间 */
//   const fullscreenAdState = useLocalStorage<Record<number, number>>('MwU92MD4slarNjdgil3boe', {})

//   // const ADS_UNIT_ID ='/22857857566/easyfun-test-reward'
//   const ADS_UNIT_ID = '/22857857566/easyfun.gg_rewarded'
//   // 间隔半小时一次
//   const INTERVAL_TIME = 60 * 30 * 1000

//   const adJsLoadSuccess = ref(false)
//   const fullscreenSlot = ref<any>()
//   const adLoadReady = ref<AnyFn>()
//   const recordCb = ref<AnyFn>()

//   const timestamp = useTimestamp({ offset: 0, interval: 1000 })
//   const isNeedSeeAds = computed(() => {
//     const preViewTime = fullscreenAdState.value[unref(gameId)] || 0
//     return timestamp.value >= preViewTime
//   })

//   function updateIntervalTime(delay: number) {
//     fullscreenAdState.value[unref(gameId)] = Date.now() + delay
//   }

//   async function loadAdsJs() {
//     try {
//       await loadJsFile(`https://securepubads.g.doubleclick.net/tag/js/gpt.js`)
//       adJsLoadSuccess.value = true
//     }
//     catch (error) {
//       adJsLoadSuccess.value = false
//     }

//     window.stpd = window.stpd || { que: [] }
//     return adJsLoadSuccess.value
//   }

//   async function initAds() {
//     await loadAdsJs()
//     if (adJsLoadSuccess.value) {
//       const googletag = window.googletag || {}
//       googletag.cmd = googletag.cmd || []
//       // https://developers.google.com/publisher-tag/guides/control-ad-loading
//       googletag.cmd.push(() => {
//         // https://developers.google.com/publisher-tag/reference
//         fullscreenSlot.value = googletag.defineOutOfPageSlot(ADS_UNIT_ID, googletag.enums.OutOfPageFormat.REWARDED)
//         fullscreenSlot.value && fullscreenSlot.value.addService(googletag.pubads())
//         // https://developers.google.com/publisher-tag/reference#googletag.events.SlotOnloadEvent
//         // 广告加载成功回调 SlotOnloadEvent
//         googletag.pubads().addEventListener('rewardedSlotReady', readyReward)
//         // 提前退出广告回调
//         googletag.pubads().addEventListener('rewardedSlotClosed', dismissReward)
//         // 看完广告回调
//         googletag.pubads().addEventListener('rewardedSlotGranted', giveReward)
//         // Disable initial load.
//         // This prevents GPT from automatically fetching ads when display is called.
//         googletag.pubads().disableInitialLoad()
//         googletag.enableServices()
//         googletag.display(fullscreenSlot.value)
//         // refresh 不传刷新全部 要么刷新 [指定单元格]
//         // googletag.pubads().refresh([rewardedSlot.value])
//       })
//     }
//   }

//   function readyReward(evt: any) {
//     console.info('>>>>>>>>>>>> rewardedSlotReady', evt)
//     // 当开始看的时候才执行
//     adLoadReady.value = evt.makeRewardedVisible
//   }

//   function giveReward(evt: any) {
//     const googletag = window.googletag || {}
//     console.info('>>>>>>>>>>>> rewardedSlotClosed', evt)
//     googletag.pubads().removeEventListener('rewardedSlotClosed', dismissReward)
//     updateIntervalTime(INTERVAL_TIME)
//     recordCb.value?.()
//   }

//   function dismissReward(evt: any) {
//     const googletag = window.googletag || {}
//     console.info('>>>>>>>>>>>> reward dismissed')
//     googletag.destroySlots([evt.rewardedSlot])
//   }

//   /**
//    * 开始看广告
//    * @param recordCb 看广告成功回调
//    */
//   function startLoadAds(recordCbFn?: AnyFn) {
//     recordCb.value = recordCbFn
//     // refresh 不传刷新全部 要么刷新 [指定单元格]
//     googletag.pubads().refresh([rewardedSlot.value])
//     // 加载失败就让他全屏吧
//     if (adJsLoadSuccess.value) {
//       console.info('>>>>>>>>>>>> ad js loaded')

//       window.stpd = window.stpd || { que: [] }
//       const googletag = window.googletag || {}
//       googletag.cmd = googletag.cmd || []

//       const rewardedSlot = ref<any>()

//       // https://developers.google.com/publisher-tag/guides/control-ad-loading
//       googletag.cmd.push(() => {
//         // https://developers.google.com/publisher-tag/reference

//         // /22857857566/easyfun-test-reward
//         // /22857857566/easyfun.gg_rewarded
//         rewardedSlot.value = googletag.defineOutOfPageSlot('/22857857566/easyfun.gg_rewarded', googletag.enums.OutOfPageFormat.REWARDED)
//         rewardedSlot.value && rewardedSlot.value.addService(googletag.pubads())
//         // Disable initial load.
//         // This prevents GPT from automatically fetching ads when display is called.
//         googletag.pubads().disableInitialLoad()
//         googletag.enableServices()
//         // 广告加载成功回调
//         googletag.pubads().addEventListener('rewardedSlotReady', readyReward)
//         // 提前退出广告回调
//         googletag.pubads().addEventListener('rewardedSlotClosed', dismissReward)
//         // 看完广告回调
//         googletag.pubads().addEventListener('rewardedSlotGranted', giveReward)

//         googletag.display(rewardedSlot.value)
//       })
//     }
//     else {
//       console.info('>>>>>>>>>>>> ad js load error')
//       // 1分钟后点击的时候再加载一次
//       updateIntervalTime(60 * 1000)
//       recordCb.value?.()
//     }
//   }

//   return { isNeedSeeAds, startLoadAds }
// }

export function useGameAdsState(gameId: MaybeRef<number>) {
/** 全屏广告 key:游戏ID value:下次观看时间 */
  const fullscreenAdState = useLocalStorage<Record<number, number>>('MwU92MD4slarNjdgil3boe', {})
  // 间隔半小时一次
  const INTERVAL_TIME = 60 * 30 * 1000

  const timestamp = useTimestamp({ offset: 0, interval: 1000 })
  const isNeedSeeAds = computed(() => {
    const preViewTime = fullscreenAdState.value[unref(gameId)] || 0
    return timestamp.value >= preViewTime
  })

  /** 增加下次看广告的cd 默认半小时 可设置其余时间 */
  function updateIntervalTime(times = INTERVAL_TIME) {
    fullscreenAdState.value[unref(gameId)] = Date.now() + times
  }

  return { isNeedSeeAds, updateIntervalTime }
}

/** 全屏奖励广告 */
export function useRewardAds(viewSuccessCb?: AnyFn, viewSkipCb?: AnyFn) {
  // const ADS_UNIT_ID ='/22857857566/easyfun-test-reward'
  const ADS_UNIT_ID = '/22857857566/easyfun.gg_rewarded'

  const rewardAdReady = ref<boolean>(false)
  const loadingAds = ref(false)

  function readyReward(evt: any) {
    console.info('>>>>>>>>>>>> rewarded Slot Ready', evt)
    loadingAds.value = false

    rewardAdReady.value = true
    console.info('>>>>>>>>>>>> make Rewarded Visible', evt)
    evt.makeRewardedVisible()
  }

  function giveReward(evt: any) {
    console.info('>>>>>>>>>>>> rewarded Slot Closed', evt)
    viewSuccessCb?.()
  }

  function dismissReward(evt: any) {
    const googletag = window.googletag || {}
    console.info('>>>>>>>>>>>> reward dismissed', evt)
    googletag.destroySlots([evt.rewardedSlot])
  }

  async function initAds() {
    try {
      await loadJsFile(`https://securepubads.g.doubleclick.net/tag/js/gpt.js`)
      window.stpd = window.stpd || { que: [] }
      console.info('>>>>>>>>>>>> gpt ads js load success')
    }
    catch (error) {
      console.warn('>>>>>>>>>>>> gpt ads js load error')
    }
  }

  function fallback(timeout: number) {
    setTimeout(() => {
      if (!rewardAdReady.value) {
        console.warn('>>>>>>>>>>>> rewarded fallback', timeout)
        loadingAds.value = false
        viewSkipCb?.()
      }
    }, timeout)
  }

  function startLoadAds() {
    loadingAds.value = true
    rewardAdReady.value = false

    if (window.googletag) {
      fallback(3000)
      const googletag = window.googletag || {}
      googletag.cmd = googletag.cmd || []
      console.info('>>>>>>>>>>>> start load ads')
      googletag.cmd.push(() => {
        // https://developers.google.com/publisher-tag/reference
        const rewardSlot = googletag.defineOutOfPageSlot(ADS_UNIT_ID, googletag.enums.OutOfPageFormat.REWARDED)
        rewardSlot && rewardSlot.addService(googletag.pubads())
        // console.info('>>>>>>>>>>>> rewardSlot', rewardSlot)
        googletag.enableServices()
        // https://developers.google.com/publisher-tag/reference#googletag.events.SlotOnloadEvent
        // 广告加载成功回调 SlotOnloadEvent
        googletag.pubads().addEventListener('rewardedSlotReady', readyReward)
        // 提前退出广告回调
        googletag.pubads().addEventListener('rewardedSlotClosed', dismissReward)
        // 看完广告回调
        googletag.pubads().addEventListener('rewardedSlotGranted', giveReward)

        googletag.display(rewardSlot)
        // https://goo.gle/gpt-message#154
        // googletag.pubads().refresh([rewardSlot])
      })
    }
    else {
      fallback(2000)
    }
  }

  return { initAds, startLoadAds, loadingAds }
}
